<template>
    <div class="menusSetting">
        <tab @getTab="getTab"></tab>
        <div id='content' v-if="status === 'content'">
            <div class='headerSerc-item'>
                <span>{{setTingObj.menuConfig.title}}</span>
                <menusConfig :setTingObj="setTingObj"></menusConfig>
            </div>
        </div>
        <div id='style' v-if="status ==='style'">
            <div class='headerSerc-item'>
                <span>{{setTingObj.tabConfig.title}} ({{setTingObj.tabConfig.tabList[setTingObj.tabConfig.type].name}})</span>
                <radio :list="setTingObj.tabConfig.tabList" :type="setTingObj.tabConfig.type" @change="updateTypeTabConfig"></radio>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.menuStyle.title}} ({{setTingObj.menuStyle.list[setTingObj.menuStyle.type].val}})</span>
                <radio :list="setTingObj.menuStyle.list" :type="setTingObj.menuStyle.type" @change="updateMenuStyle"></radio>
            </div>
            <template v-if="setTingObj.tabConfig.type === 1">
                <div class='headerSerc-item'>
                    <span>{{setTingObj.rowsNum.title}} ({{setTingObj.rowsNum.list[setTingObj.rowsNum.type].val}})</span>
                    <radio :list="setTingObj.rowsNum.list" :type="setTingObj.rowsNum.type" @change="updateRowsNum"></radio>
                </div>
                <div class='headerSerc-item'>
                    <span>{{setTingObj.number.title}} ({{setTingObj.number.list[setTingObj.number.type].val}})</span>
                    <radio :list="setTingObj.number.list" :type="setTingObj.number.type" @change="updateNumber"></radio>
                </div>
            </template>
            <div class='headerSerc-item'>
                <span>{{setTingObj.bgColor.title}}</span>
                <color :colorObj="setTingObj.bgColor"></color>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.titleColor.title}}</span>
                <color :colorObj="setTingObj.titleColor"></color>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.bgStyle.title}} ({{setTingObj.bgStyle.list[setTingObj.bgStyle.type].val}})</span>
                <radio :list="setTingObj.bgStyle.list" :type="setTingObj.bgStyle.type" @change="updateBgStyle"></radio>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.prConfig.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.prConfig"></sliderAndInput>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.mbConfig.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.mbConfig"></sliderAndInput>
            </div>
        </div>
    </div>
</template>

<script>
import tab from '@/components/decoration/common/tab.vue'
import menusConfig from '@/components/decoration/common/menusConfig.vue';
import sliderAndInput from '@/components/decoration/common/sliderAndInput.vue';
import radio from '@/components/decoration/common/radio.vue';
import color from '@/components/decoration/common/color.vue';
export default {
    components:{
        sliderAndInput,
        tab,
        menusConfig,
        radio,
        color,
    },
    props:{
        setTingObj: {
            type: Object,
            default: {}
        },
    },
    data(){
        return{
            status: 'content'
        }
    },
    methods:{
        getTab(e){
            this.status = e
        },
        updateTypeTabConfig(type){
            this.setTingObj.tabConfig.type = type
        },
        updateMenuStyle(type){
            this.setTingObj.menuStyle.type = type
        },
        updateBgStyle(type){
            this.setTingObj.bgStyle.type = type
        },
        updateRowsNum(type){
            this.setTingObj.rowsNum.type = type
        },
        updateNumber(type){
            this.setTingObj.number.type = type
        }
    }
}
</script>

<style scoped lang="scss">

</style>